import { StyleSheet } from 'react-native'
import theme from '../../../theme'

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: 'white',
    },
    image: {
        width: 120,
        height: 120,
        alignSelf: 'center',
    },
    title: {
        fontSize: 20,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        marginTop: 8,
        paddingHorizontal: 12,
    },
    description: {
        fontSize: 16,
        marginTop: 8,
        fontWeight: 'normal',
        color: theme.colors.darkGray,
        paddingHorizontal: 12,
    },
    buttonContainer: {
        flexDirection: 'column',
        position: 'absolute',
        padding: 12,
        bottom: 0,
        width: '100%',
    },
    mainButton: {
        width: '100%',
        height: 40,
        backgroundColor: theme.colors.colorPrimary,
        padding: 10,
        borderRadius: 10,
        alignItems: 'center',
        justifyContent: 'center',
    },
    mainButtonText: {
        fontSize: 15,
        color: 'white',
        fontWeight: 'bold',
        textAlign: 'center',
    },
    spacer: {
        height: 75,
    },
})

export default styles
